import React, { RefObject, useEffect, useRef, useState } from "react";
import "./QualityCheckListCard.scss";
import { SkuDetailSchema } from "../../models/SkuListSchema";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import DeliveryLocationSelector from "../DeliveryLocationSelector/DeliveryLocationSelector";
import { useSelector } from "react-redux";
import { getUserWarehouseAddresses } from "../../redux/user/userSelector";
import TagsDropdown from "../TagsDropdown/TagsDropdown";
import OutsideAlerter from "../../utils/OutsideClickDetector";
import { FilterOptionSchema } from "../Filter/filter.data";
import { toastOptions } from "../../utils/toast";
import { toast } from "react-toastify";
import { formatDateWithYear } from "../../utils/date-util";
import { useNavigate } from "react-router-dom";
import { QualityCheckListSchema } from "../../models/QualityCheck";
import { QUOTE_STATUS_PROPERTY_MAP } from "../../constants/QuotesData";
import {
  breakPointObserver,
  ScreenSizes,
} from "../../utils/BreakpointObserver";

interface QCProps {
  qualityCheck: QualityCheckListSchema;
}

const QualityCheckListCard: React.FC<QCProps> = ({ qualityCheck }) => {
  const navigate = useNavigate();
  const [breakpoint, setBreakpoint] = useState("");

  useEffect(() => {
    breakPointObserver(setBreakpoint);
  }, [breakpoint]);

  const handleNavigationToDetail = (id: number) => {
    navigate(`/quality-checks/detail/${id}`);
  };

  return (
    <>
      {breakpoint === ScreenSizes.MOBILE ? (
        <div
          onClick={() =>
            handleNavigationToDetail(
              qualityCheck.procurement_request_product_delivery_id
            )
          }
          className="qc-list-card-mobile-main-container p-12 flex-column gap-16 cursor-pointer"
        >
          <div className="flex-row align-items-ceter ">
            <div className="flex-row gap-9 align-items-center">
              <p className="qc-uuid-container px-12 py-4 xetgo-font-tag">
                {qualityCheck.po_number}
              </p>
              <p className="border-box flex-row gap-8 xetgo-font-tag  justify-content-space-between full-width bold">
                <span style={{ color: "#4A4A4A" }}>
                  {" "}
                  {qualityCheck.delivered_quantity}
                </span>
                <span style={{ color: "#A3A3A3" }}>
                  {qualityCheck.measurement_unit}
                </span>
              </p>
            </div>
            <div className="flex-row align-items-center justify-content-end flex-1">
              <p
                className="quality-check-current-status flex-row align-items-center justify-content-center p-6 xetgo-font-tag bold"
                style={{
                  color:
                    QUOTE_STATUS_PROPERTY_MAP[qualityCheck.po_status]?.color ??
                    "white",
                  backgroundColor:
                    QUOTE_STATUS_PROPERTY_MAP[qualityCheck.po_status]
                      ?.backgroundColor ?? "#880000",
                }}
              >
                {qualityCheck.po_status ? qualityCheck.po_status : "Pending"}
              </p>
            </div>
          </div>
          <div className="flex-row gap12">
            <div className="flex-1 description xetgo-font-tag flex-column gap-12 sku-name">
              <p style={{ color: "#111111" }} className="bold ">
                {qualityCheck.vendor_details.vendor_name}
              </p>
              <p style={{ color: "#919191", wordBreak: "break-word" }}>
                {"qualityCheck.vendor_details.vendor_poc"}
              </p>
            </div>
            <p
              style={{ textTransform: "uppercase" }}
              className="sku-name border-box flex-row gap-8 xetgo-font-tag  bold"
            >
              {qualityCheck.sku_name}
            </p>
          </div>
          <div className="flex-column gap-12">
            <div className="flex-row align-items-center justify-content-space-between">
              <p style={{ color: "#111111" }} className="bold xetgo-font-tag">
                Delivery Date
              </p>
              <p
                style={{ color: "#4A4A4A" }}
                className="sku-name border-box xetgo-font-tag bold"
              >
                {formatDateWithYear(qualityCheck.actual_delivery_date)}
              </p>
            </div>
            <div className="flex-row align-items-center justify-content-space-between">
              <p style={{ color: "#111111" }} className="bold xetgo-font-tag">
                Approved
              </p>
              <p className="approved-pill bold xetgo-font-mini px-8 py-4">
                {qualityCheck.approved_quantity
                  ? qualityCheck.approved_quantity
                  : "-"}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          onClick={() =>
            handleNavigationToDetail(
              qualityCheck.procurement_request_product_delivery_id
            )
          }
          className="quality-check sku-products-wrapper flex-row xetgo-font-tag"
        >
          <p
            style={{ color: "#AA5200" }}
            className="flex-row index p-12 border-box"
          >
            {qualityCheck.uuid}
          </p>
          <p className="sku-name border-box flex-row gap-8 p-12 xetgo-font-tag  bold">
            {qualityCheck.sku_name}
          </p>
          <p className="sku-name border-box flex-row gap-8 p-12 xetgo-font-tag  bold">
            <p className="qc-uuid-container px-12 py-4">
              {qualityCheck.po_number}
            </p>
          </p>{" "}
          <div className="sku-name flex-column gap-12 align-items-center p-12">
            <p className="border-box flex-row gap-8 xetgo-font-tag  justify-content-space-between full-width bold">
              <span style={{ color: "#4A4A4A" }}>
                {" "}
                {qualityCheck.delivered_quantity}
              </span>
              <span style={{ color: "#A3A3A3" }}>
                {qualityCheck.measurement_unit}
              </span>
            </p>
            {qualityCheck.approved_quantity && (
              <p className="approved-pill bold xetgo-font-mini px-8 py-4">
                {qualityCheck.approved_quantity} - Approved
              </p>
            )}
          </div>
          <p
            style={{ color: "#4A4A4A" }}
            className="sku-name border-box p-12 xetgo-font-tag bold"
          >
            {formatDateWithYear(qualityCheck.actual_delivery_date)}
          </p>
          <div className="flex-1 p-12 description flex-column gap-12 sku-name">
            <p style={{ color: "#111111" }} className="bold ">
              {qualityCheck.vendor_details.vendor_name}
            </p>
            <p style={{ color: "#919191" }}>
              {qualityCheck.vendor_details.vendor_poc}
            </p>
          </div>{" "}
          <div className="flex-1 p-12 description">
            <p
              className="quality-check-current-status flex-row align-items-center justify-content-center p-6 xetgo-font-tag bold"
              style={{
                color:
                  QUOTE_STATUS_PROPERTY_MAP[qualityCheck.po_status]?.color ??
                  "white",
                backgroundColor:
                  QUOTE_STATUS_PROPERTY_MAP[qualityCheck.po_status]
                    ?.backgroundColor ?? "#880000",
              }}
            >
              {qualityCheck.po_status ? qualityCheck.po_status : "Pending"}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default QualityCheckListCard;
